
const PaymentRoutes = [
  {
    path: '/ecommerce/payments',
    name: 'payments',
    component: () => import(/* webpackChunkName: "payment" */ './views/PaymentView.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Payments',
          path: '/ecommerce/payments',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'payments',
        component: () => import(/* webpackChunkName: "payment" */ './components/Payments.vue'),
        meta: {
          breadCrumbs: [
            {
              name: 'Payments',
              path: '/ecommerce/payments',
            },
          ],
        },
      },
    ],
  },
];

export default PaymentRoutes;
